/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type FlyoutFilterProduct } from '@/features/fulfillment';
import type { CounterData } from '@/components/Cart/CommonCounterPart/PreOrderQuantitySelector/types';

export const calculateItemUnitPrice = (props: {
  discountedStrikeThroughPrice?: number;
  hasDealId?: boolean;
  productTotalPrice?: string;
  data: CounterData;
  strikeThroughPricingEnabled: boolean;
  filterproduct?: FlyoutFilterProduct;
}) => {
  const {
    discountedStrikeThroughPrice,
    hasDealId,
    productTotalPrice,
    data,
    strikeThroughPricingEnabled,
    filterproduct,
  } = props;
  let showStrikeThroughPricing = false;
  if (strikeThroughPricingEnabled) {
    showStrikeThroughPricing = true;
  }
  const discountedPrice = filterproduct?.skuPricingAndAvailability?.discountedPrice;

  let amount;

  if (discountedStrikeThroughPrice && !hasDealId) {
    amount = discountedStrikeThroughPrice;
  } else if (showStrikeThroughPricing && discountedPrice && !hasDealId) {
    amount = Number(discountedPrice);
  } else {
    amount =
      data?.lineItemPriceInfo?.unitPrice !== undefined && data?.lineItemPriceInfo?.unitPrice > 0
        ? data.lineItemPriceInfo.unitPrice
        : parseFloat(productTotalPrice ?? '0.00');
  }
  return amount;
};
